export const validatorPositive = (value) => {
  if (value >= 0) {
    return true;
  }
  return false;
};

export const validatorPassword = (password) => {
  /* eslint-disable no-useless-escape */
  const regExp = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password);
  return validPassword;
};

export const validatorMobile = (mobile) => {
  /* eslint-disable no-useless-escape */
  const regExp = /9\d{9}$/ || /09\d{9}$/;
  /* eslint-enable no-useless-escape */
  const validMobile = regExp.test(mobile);

  return validMobile;
};
export const validatorNotArabic = (password) => {
  /* eslint-disable no-useless-escape */
  const regExp = /[\u0600-\u06FF]/;
  /* eslint-enable no-useless-escape */
  const validNotArabic  = !regExp.test(password);

  return validNotArabic ;
};
export const validatorTotalPersian = (name) => {
  /* eslint-disable no-useless-escape */
  const regExp = /^[\u0600-\u06FF\s]+$/;
  /* eslint-enable no-useless-escape */
  const validTotalPersian  = regExp.test(name);

  return validTotalPersian;
};

export const validatorMobileEmail = (mobileEmail) => {
  /* eslint-disable no-useless-escape */
  const regExpPhone =  /9\d{9}$/ || /09\d{9}$/
  const regExpEmail =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
  /* eslint-enable no-useless-escape */
  const validMobileEmail = (regExpPhone.test(mobileEmail) || regExpEmail.test(mobileEmail) );

  return validMobileEmail;
};

export const validatorEmail = (email) => {
  /* eslint-disable no-useless-escape */
  const regExp =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
  /* eslint-enable no-useless-escape */
  const validEmail = regExp.test(email);
  return validEmail;
};

export const validatorCreditCard = (creditnum) => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/;
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum);
  return validCreditCard;
};

export const validatorUrlValidator = (val) => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  /* eslint-disable no-useless-escape */
  const re =
    /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
  /* eslint-enable no-useless-escape */
  return re.test(val);
};
